export const mcpRequestKey = (slug: string) => `mcp_consent_${slug}`;
